export default "__VITE_ASSET__567e101b__"